














import {
  Component, Vue, Watch, mixins, mapState,
} from '@samclick-commons';
import SamclickMixins from '@/utils/mixins';
import {
  AuthorizationStore, CommonsStore, Payload, ReferralStore,
} from '@/state/modules';


class ReferralLinksState {
     referral: string = ''
}

    @Component({
      /**
         * Imported components
         * */
      components: {},
      /**
         * Stores values
         * */
      computed: {
        ...mapState({
          referral: (state: any) => state.referral.ReferralStore.referral,
        }),
      },
      /**
         * Component properties
         * */
      props: {},
    })
export default class ReferralLinks extends mixins(SamclickMixins) {
        /**
         * Local state
         * */
        state = new ReferralLinksState();

        BASE_SITE_URL = process.env.VUE_APP_BASE_SITE_URL;

        /**
         * Watchers
         * */
        @Watch('componentState.var')
        sampleWatcher(newVal: string, oldVal: string) {

        }

        /**
         * Methods
         * */
        getReferralLink() {
          const afffId = AuthorizationStore.currentLoggedUserInState.id;
          ReferralStore.getReferral(new Payload({ affiliateID: afffId })).then((response) => {
            const affInfo = response.data;
            this.state.referral = affInfo.ReferralLink;
          });
        }


        /**
         * Computed
         * */
        get referralLink() {
          const self = this;
          return `${self.BASE_SITE_URL}tier?id=${this.state.referral}`;
        }

        /**
         * Lifecycle hooks
         * */
        created() {
        }

        mounted() {
          this.getReferralLink();
        }

        beforeUpdate() {
        }
}
